import { cn } from "@/lib/utils";
import { TrendingUp, TrendingDown } from "lucide-react";

export function StatCard({ label, value, sub, icon: Icon, delta, accent = "#00C2FF", testid }) {
    const positive = delta >= 0;
    return (
        <div
            data-testid={testid}
            className="bg-surface border border-border rounded-sm p-5 hover:border-white/25 transition-colors duration-200"
        >
            <div className="flex items-start justify-between">
                <span className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground font-semibold">{label}</span>
                {Icon && (
                    <span className="grid place-items-center w-7 h-7 rounded-sm" style={{ background: `${accent}1a` }}>
                        <Icon className="w-4 h-4" style={{ color: accent }} />
                    </span>
                )}
            </div>
            <div className="mt-3 font-mono font-bold text-2xl md:text-3xl tracking-tight text-white">{value}</div>
            <div className="mt-1 flex items-center gap-2">
                {sub && <span className="text-xs text-muted-foreground">{sub}</span>}
                {delta !== undefined && delta !== null && (
                    <span className={cn("inline-flex items-center gap-1 text-xs font-mono", positive ? "text-success" : "text-alert")}>
                        {positive ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                        {positive ? "+" : ""}{delta}
                    </span>
                )}
            </div>
        </div>
    );
}
